// Mock data para o portfólio da Forttana Eventos
export const projectsData = [
  {
    id: 1,
    title: "Stand Feira Tecnologia",
    category: "feiras-comerciais",
    categoryName: "Feiras Comerciais",
    image: "https://images.unsplash.com/photo-1632383380175-812d44ec112b",
    description: "Stand moderno para feira de tecnologia com design interativo e iluminação LED personalizada.",
    area: "120m²",
    client: "Tech Innovations",
    year: "2024"
  },
  {
    id: 2,
    title: "Exposição Arte Contemporânea",
    category: "exposicoes",
    categoryName: "Exposições",
    image: "https://images.unsplash.com/photo-1743119638006-a01d4625745d",
    description: "Espaço expositivo minimalista com foco na valorização das obras de arte contemporânea.",
    area: "200m²",
    client: "Galeria Arte Moderna",
    year: "2024"
  },
  {
    id: 3,
    title: "Stand Automotivo Premium",
    category: "eventos",
    categoryName: "Eventos Corporativos",
    image: "https://images.unsplash.com/photo-1543499605-27b5abdfeb04",
    description: "Stand corporativo para lançamento de produto com área VIP, test drive e experiência imersiva.",
    area: "300m²",
    client: "AutoBrasil Premium",
    year: "2023"
  },
  {
    id: 4,
    title: "Quiosque Shopping Premium",
    category: "quiosques",
    categoryName: "Quiosques & PDVs",
    image: "https://images.unsplash.com/photo-1560225672-ee30c3411c14",
    description: "Quiosque moderno com design sustentável, materiais eco-friendly e tecnologia integrada.",
    area: "25m²",
    client: "EcoStyle Brasil",
    year: "2024"
  },
  {
    id: 5,
    title: "Complexo Feira Internacional",
    category: "feiras-comerciais",
    categoryName: "Feiras Comerciais",
    image: "https://images.unsplash.com/photo-1553545894-cf4d7f2bf8ac",
    description: "Complexo de stands para feira internacional com múltiplos expositores e área de networking.",
    area: "500m²",
    client: "Expo Internacional Brasil",
    year: "2023"
  },
  {
    id: 6,
    title: "Cenografia Museu Interativo",
    category: "cenografias",
    categoryName: "Cenografias",
    image: "https://images.unsplash.com/photo-1647792873139-19943a113a3f",
    description: "Cenografia moderna para exposição permanente com tecnologia touchscreen e realidade aumentada.",
    area: "150m²",
    client: "Museu da Inovação",
    year: "2024"
  },
  {
    id: 7,
    title: "1º Exposição FIEGO IRRIGO Cristalina",
    category: "stands-modulares",
    categoryName: "Stands Modulares",
    image: "https://images.unsplash.com/photo-1770211464422-b0bbf14d4960?auto=format&fit=crop&w=1600&q=80",
  images: [
    "https://images.unsplash.com/photo-1770211464422-b0bbf14d4960?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1770211464274-8f3b37d77a7d?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1770211464264-a7b0d6f6b473?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1770211464286-9badd5104cad?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1770211540306-602cf1172c24?auto=format&fit=crop&w=1600&q=80"
  ],
    description: "Stands modulares para exposição temporaria com padronismo minimalista e facil adaptação.",
    area: "1300m²",
    client: "Associação dos Irrigantes do estado de Goiás",
    year: "2022"
  },
  {
    id: 8,
    title: "FAICRIS ACAIC/CDL Edição 2025",
   category: "stands-modulares",
    categoryName: "Stands Modulares",
    image: "https://images.unsplash.com/photo-1770210676227-e17265287d01?auto=format&fit=crop&w=1600&q=80",
  images: [
    "https://images.unsplash.com/photo-1770210676227-e17265287d01?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1770210676220-aba8bec582fa?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1770210676195-f30431d3bf90?auto=format&fit=crop&w=1600&q=80",
    "https://images.unsplash.com/photo-1770210556583-f8e3f3f8bc09?auto=format&fit=crop&w=1600&q=80"
  ],
    description: "Stands padrões ambientados para exposição temporaria, visando o Empreendedorismo, Inovação e Crescimento.",
    area: "700m²",
    client: "Associação Comercial Agro Industrial de Cristalina",
    year: "2025"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Briefing & Consultoria",
    description: "Entendemos sua necessidade, público-alvo e objetivos do projeto",
    icon: "MessageCircle",
    image: "https://images.unsplash.com/photo-1553545894-cf4d7f2bf8ac"
  },
  {
    id: 2,
    title: "Projeto & Design 3D",
    description: "Desenvolvemos o projeto completo com renders 3D fotorrealísticos",
    icon: "Palette",
    image: "https://images.unsplash.com/photo-1647792873139-19943a113a3f"
  },
  {
    id: 3,
    title: "Aprovação & Refinamento",
    description: "Ajustamos todos os detalhes até alcançar sua visão perfeita",
    icon: "CheckCircle",
    image: "https://images.unsplash.com/photo-1743119638006-a01d4625745d"
  },
  {
    id: 4,
    title: "Execução & Montagem",
    description: "Construímos e montamos com equipe especializada e materiais premium",
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1634231647709-06609f7dd3ca"
  }
];

export const services = [
  {
    title: "Stands para Feiras",
    description: "Projetos únicos que atraem visitantes e geram oportunidades",
    icon: "Building"
  },
  {
    title: "Quiosques & PDVs",
    description: "Pontos de venda estratégicos com design que converte",
    icon: "Store"
  },
  {
    title: "Ambientações",
    description: "Transformamos espaços em experiências memoráveis",
    icon: "Lightbulb"
  },
  {
    title: "Cenografias",
    description: "Criações artísticas que impactam e emocionam o público",
    icon: "Palette"
  }
];

export const testimonials = [
  {
    name: "Carlos Eduardo Silva",
    company: "Tech Innovations",
    text: "A Forttana superou todas as expectativas! O stand ficou incrível e trouxe muitos visitantes qualificados.",
    avatar: "CS"
  },
  {
    name: "Marina Santos",
    company: "AutoBrasil Premium", 
    text: "Profissionalismo exemplar. Entregaram exatamente o que prometeram, no prazo e com qualidade impecável.",
    avatar: "MS"
  },
  {
    name: "Roberto Costa",
    company: "Expo Internacional",
    text: "Já trabalhamos em vários projetos juntos. A qualidade e atenção aos detalhes da Forttana é impressionante!",
    avatar: "RC"
  }
];

export const contactData = {
  email: "comercial@forttanaeventos.com.br",
  phone: "(61) 98125-5035",
  phone2: "(61) 99221-8513", 
  address: "Brasília - DF, Brasil",
  whatsapp: "5561981255035",
  instagram: "@forttana_eventos",
  website: "www.forttanaeventos.com.br"
};
